import React,  { useEffect }  from "react";
import Start_Btn from "../../common/start-btn/Start_Btn";
import { useDispatch, useSelector } from "react-redux";
import { GetAllaboutbanner } from "../../../redux/aboutus";


const About_Banner = ({banner}) => {

//    const dispatch = useDispatch();
//  const banner = useSelector((state) => state?.aboutus?.aboutbanner);

//   useEffect(() => {
//     dispatch(GetAllaboutbanner());
//   }, [dispatch]);


  return (
    <section className="About_Banner Career_Banner">
      <div className="container">
        <div className="career_content">
          <h5 className="career_title">
            {/* About Our Career Guidance Platform */}
            {banner?.name}
            </h5>
          <p className="career_text">
            {/* Empowering students with structured career assessments and expert
            counselling while supporting parents in making informed decisions
            for their children’s future. */}
           {banner?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default About_Banner;
